<script setup lang="ts">
import { computed, useSlots } from 'vue';
import { classNames } from '@/js/lib/bem';

const props = withDefaults(
  defineProps<{
    sticky?: boolean
  }>(),
  {
    sticky: true,
  },
);

const cn = classNames('profile-header');
const slots = useSlots();

const hasLeft = computed(() => Boolean(slots.left));
const hasRight = computed(() => Boolean(slots.right));
const isVisible = computed(() => hasLeft.value || hasRight.value);

const headerClasses = computed(() =>
  cn({
    sticky: props.sticky || undefined,
  }),
);
</script>

<template>
  <header v-if="isVisible" :class="headerClasses">
    <div v-if="hasLeft" :class="cn('left')">
      <slot name="left" />
    </div>
    <div v-if="hasRight" :class="cn('right')">
      <slot name="right" />
    </div>
  </header>
</template>

<style lang="scss" scoped>
.profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
  padding: 16px 32px;
  border-bottom: 1px solid #e0e0e0;

  &_sticky {
    position: sticky;
    top: 0;
    z-index: 5;
    background-color: var(--color-white);
  }

  &__left,
  &__right {
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 0;
  }

  &__right {
    flex-shrink: 0;
    margin-left: auto;
  }

  @media (max-width: 768px) {
    padding: 16px;
    flex-direction: column;
    gap: 24px;
    align-items: flex-start;

    &__right {
      margin-left: 0;
      width: 100%;
    }
  }
}
</style>
